<div class="informe-diario-container">
  <div class="informe-header">
    <h3 class="informe-titulo">
      <mat-icon>assessment</mat-icon>
      Informe Diario
    </h3>
    <div style="display: flex; align-items: center; gap: 8px">
      <div class="selector-cliente">
        <app-cliente-selector
          [ngModel]="idClienteSeleccionado"
          (clienteIdChange)="onClienteSeleccionado($event)"
          placeholder="Cliente"
        ></app-cliente-selector>
      </div>
      <irx-segmentado
        [value]="periodo"
        (change)="togglePeriodo($event.value)"
      >
        <irx-segmento [value]="7">7 días</irx-segmento>
        <irx-segmento [value]="30">30 días</irx-segmento>
      </irx-segmentado>
      <button
        irxBotonIcono
        (click)="descargarInforme()"
        [disabled]="!informeActual"
        tooltip="Ver / imprimir informe"
      >
        <mat-icon>print</mat-icon>
      </button>
      <div style="width: 160px">
        <app-datetime-picker
          [date]="fechaISO"
          (dateChange)="fechaISO = $event"
          pickerMode="calendar"
          placeholder="Fecha informe"
        ></app-datetime-picker>
      </div>
      <button
        irxBotonIcono
        (click)="generarInforme()"
        [disabled]="cargando"
        tooltip="Generar informe"
      >
        <mat-icon>note_add</mat-icon>
      </button>
    </div>
  </div>

  @if (cargando) {
    <div class="cargando">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  } @else if (informes.length === 0) {
    <div class="sin-datos">
      <mat-icon>inbox</mat-icon>
      <p>No hay informes generados para los últimos {{ periodo }} días</p>
    </div>
  } @else {
    <app-carrusel
      [itemCount]="informes.length"
      (indexChange)="onIndexChange($event)"
    >
      @if (informeActual) {
        <div class="informe-panel">
          <!-- Fecha -->
          <p class="slide-fecha">
            {{
              informeActual.periodoInicio
                | date: "EEEE d 'de' MMMM yyyy" : undefined : 'es-AR'
            }}
          </p>
          <div class="slide-content">
            <!-- KPIs esenciales -->
            <div class="kpis">
              @for (card of kpiCards; track card.title) {
                <app-stat-card [config]="card"></app-stat-card>
              }
            </div>

            <!-- Gráficos -->
            <div class="charts">
              @for (chart of charts; track chart.title) {
                <div class="chart-cell">
                  <app-chart-card [config]="chart"></app-chart-card>
                </div>
              }
            </div>
          </div>
        </div>
      }
    </app-carrusel>
  }
</div>
